import React from 'react';
import * as utils from '../../utils';
import projectRequirementsArray from '../../utils/projectRequirementsArray';
import { KnockoutDraftHeader } from '../components';

const HEADER = {
    oi: 'Review and customize your quote, or add OCP',
    ocp: 'Review your quote, or add OI'
};

const SUB_HEADER = {
    oi: "Owner's Interest",
    ocp: "Owner's Contractor Protective"
};

const HeaderBlock = ({ type, relatedEntities, status, referralMessageInDraft='', quoteStatus, quoteUnsaved = false } ) => {
    const edgeNumber = utils.submission.getEdgeNumber({ relatedEntities });
    return (
        referralMessageInDraft && referralMessageInDraft.length > 0 ? <KnockoutDraftHeader referralMessageInDraft = {referralMessageInDraft} /> :
        <header>
            <div className="h2 mt mb">
                <strong>{HEADER[type]}</strong>
            </div>
            <legend />
            <div className="h3 mt">
                {quoteStatus === 'DRAFT' || quoteUnsaved ? 
                <div style={{paddingBottom:'10px'}}>After review, you must hit "Submit" at the bottom of the page in order to receive terms</div> :
                <div>Your quote has been successfully submitted for <strong>{SUB_HEADER[type]}</strong>
                {edgeNumber ? (<span className="subheader-doc-number">#{edgeNumber}</span>) : null} </div>
                }
            </div>
        </header>
    );
};

export default HeaderBlock;
